import React from 'react';
import config from '../config';

const noop = () => null;

export default {
  getFilterMethod: () => {},
  hidePagination: false,
  isControlledPagination: false, // Used for server side pagination
  leftFooter: [],
  tableId: 'tableId', // Overwritten in decorators TODO: remove overwrite (breaking change)
  onFooterClick: noop,
  page: 1,
  pageSize: 15,
  renderCell: (cell /* eslint-disable-line */) =>
    cell.value ? (
      <span style={{ float: cell.variant === 'number' ? 'right' : 'none' }}>
        {cell.value}
      </span>
    ) : (
      <div />
    ),
  variant: config.types.BASE,
  renderTableFilters: noop,
  renderPagination: noop,
  tooltipShowOn: 'focus-hover',
  i18n: {
    title: 'No Results',
    subtitle: 'Please change filters to reset results'
  },
  shouldRenderEmptyFilterView: false,
  emptyViewFilter: null,
  minWidth: '1600px'
};
